import {Customer} from "./User";

export interface TransactionFiltersDTO {
    status?: string | null;
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
    customer_id?: string;
    search?: string;
  }

  export interface TransactionsDto {
    id: string;
    trans_code: string;
    referenceId: string;
    amount: string;
    customer_msisdn: string;
    customer_name: string;
    customer_email?: string;
    status: TransactionStatusEnum;
    commission?: string | number;
    fees?: string | number;
    currency: string;
    countryCode: string;
    paymentMethod?: any;
    callback_url?: string;
    createdAt: string;
    updatedAt?: string;
    balance?: string | number;
    externalTransactionId?: any;
    service?: {
      id?: string;
      name?: string;
      description?: string;
    };
    subscription?: {
      id: string;
      partnerService?: {
        id: string;
        service?: {
          id: string;
          name: string;
          description?: string;
        };
      };
    };
  }

  // WithdrawalDTO.ts

  export interface WithdrawalDTO {
    id?: string;
    amount: string; 
    status: TransactionStatusEnum; 
    adminNotes: string | null;
    externalTransactionId: string | null;
    paymentMethod: string | null;
    fee: string | null;
    eventLog: any; 
    createdAt: string;
    updatedAt: string;
    customer:any
    user:any 
    currency:string
  }

  export enum TransactionStatusEnum {
    INITIATED = "INITIATED",
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
    approved="approved",
    rejected="rejected"
  }

  export enum PaymentLinkStatusEnum {
    INITIATED = "INITIATED",
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
  }

  export interface Notifications {
    id?: string ;
    message?: string;
    isRead?: boolean;
    createdAt:string
  }

  export interface QueryParamsDTO {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: "code" | "detail" | "createdAt" | "updatedAt";
  type?: string;
}

export interface BalanceDto {
  id: string;
  customerId: number;
  customer?:Customer;
  totalCollected: number;
  availableBalance: number;
  pendingBalance: number;
  totalWithdrawn: number;
  totalCommissionEarned:number;
  totalProviderFees:number;
  createdAt: string;
  updatedAt: string;
}

export interface BalanceTransactionDto {
  id: string;
  balance:BalanceDto;
  balanceId:string;
  type:BalanceTransactionType;
  amount:number;
  balanceAfter:number;
  commission:number|null;
  providerFee:number|null;
  platformMargin:number|null;
  reference:string;
  comment:string|null;
  createdAt:string;

}

export enum BalanceTransactionType {
  CREDIT  = 'CREDIT',
  DEBIT   = 'DEBIT',
  PENDING = 'PENDING',
  REFUND  = 'REFUND',
  CANCEL  = 'CANCEL',
}
